<template>
  <div class="statistics-heat-map-body-grid-row"
       :class="{'statistics-heat-map-body-grid-row_last-row': isLastRow}">
    <div class="statistics-heat-map-body-grid-row-app"
         v-tooltip="`${ item.localName}`">{{ item.localName }}</div>

    <div class="statistics-heat-map-body-grid-row-body">
      <div class="statistics-heat-map-body-grid-row-body-items"
           :style="`grid-template-columns: repeat(${hoursLength}, 15px);`">
        <div v-for="(hourItem, index) in hours"
             :key="index"
             :style="`background: ${getColor(hourItem)}`"
             v-tooltip="`${hourItem}`"
             class="statistics-heat-map-body-grid-row-body-item"></div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      minutesSeparator: 25,
    };
  },

  created() {},

  props: {
    item: {
      type: Object,
    },
    isLastRow: {
      type: Boolean,
    },
    ranges: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  computed: {
    hours() {
      return Object.keys(this.item.hour).map((hourKey) => {
        return this.item.hour[hourKey];
      });
    },
    hoursLength() {
      return Object.keys(this.item.hour).length;
    },
  },

  watch: {},

  methods: {
    getRangeIndex(hourItem) {
      return this.ranges.findIndex((range) => {
        return hourItem >= range.start && hourItem <= range.end;
      });
    },
    getColor(hourItem) {
      const rangeIndex = this.getRangeIndex(hourItem);

      return {
        0: "rgba(31, 122, 31, 0.5)",
        1: "rgba(31, 122, 31, 0.65)",
        2: "rgba(31, 122, 31, 0.85)",
        3: "rgba(31, 122, 31, 1)",
        4: "rgba(230, 230, 0, 0.5)",
        5: "rgba(230, 230, 0, 0.65)",
        6: "rgba(230, 230, 0, 0.85)",
        7: "rgba(230, 230, 0, 1)",
        8: "rgba(255, 64, 0, 0.75)",
        9: "rgba(255, 64, 0, .85)",
      }[rangeIndex];
    },
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
.statistics-heat-map-body-grid-row {
  align-items: center;
  display: grid;
  grid-template-columns: 120px 1fr;
  margin-bottom: 10px;
  gap: 15px;

  .statistics-heat-map-body-grid-row-app {
    width: 120px;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .statistics-heat-map-body-grid-row-body {
    .statistics-heat-map-body-grid-row-body-items {
      display: grid;
      gap: 10px;
      justify-content: space-between;

      .statistics-heat-map-body-grid-row-body-item {
        background: #ff4000;
        height: 15px;
      }
    }
  }
}
</style>
